<template>
	<div id="InventoryTemplatesComponent" class="inventoryTemplatesComponent">
		<div class="row">
			<div class="col-md-6">
				<div class="row">
					<div class="col-md-12 form-group">
						<label for="nameInput">Nombre Planilla</label>
						<input type="email" class="form-control form-control-sm" id="nameInput" v-model="objectInventoryTemplate.name">
					</div>
					<div class="col-md-12">
						<div class="row">
							<div class="col-md-6">
								<label>Seleccione los modulos</label>
								<ul class="ul-list-store">
									<li v-for="(item, index) in listStores" :key="index">
										<div @click="(storeId != item.id) ? storeId = item.id : storeId = 0" class="pointer">
											<span v-if="storeId != item.id">+</span>
											<span v-else>-</span>
											Bodega {{ item.name }}
										</div>
										<ul v-if="item.id == storeId">
											<li v-for="(ite, inde) in listStoreRacks" :key="inde" v-if="ite.store_id == item.id">
												<div  @click="(storeRackId != ite.id) ? storeRackId = ite.id : storeRackId = 0" class="pointer">
													<span v-if="storeRackId != ite.id">+</span>
													<span v-else>-</span>
													Rack {{ ite.name }}
												</div>
												<ul v-if="ite.id == storeRackId">
													<li class="pointer li" v-for="(it, ind) in listStoreRackModulesLocal" :key="ind" v-if="it.store_rack_id == ite.id" @dblclick="addListStoreRackModulesSelected(it)">
														Modulo {{ it.name }} - Cod: {{ it.code }}
													</li>
												</ul>
											</li>
										</ul>
									</li>
								</ul>
							</div>
							<div class="col-md-6">
								<label>Modulos Seleccionados ({{objectInventoryTemplate.inventory_template_store_rack_modules.length}})</label>
								<ul>
									<li v-for="(item, index) in objectInventoryTemplate.inventory_template_store_rack_modules" :key="index" @dblclick="removeListStoreRackModulesSelected(index)" class="pointer li" style="margin-left: 5px;">
										Modulo {{ item.name }} - Cod: {{ item.code }}
									</li>
								</ul>
								<hr>
								<button class="btn btn-sm btn-block btn-primary" :disabled="(objectInventoryTemplate.inventory_template_store_rack_modules.length == 0) || (objectInventoryTemplate.name.trim().length < 3) || savingInventoryTemplate == true" @click="saveInventoryTemplateLocal">
									<span v-if="savingInventoryTemplate == true">Creando Planilla...</span>
									<span v-else>Crear Planilla</span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6" style="border-left: 1px solid #eee">
				<label for="nameInput">
					Planillas 
					<input type="text" placeholder="Buscar..." v-model="searchInventoryTemplates">
				</label> 
				
				<table class="table table-sm">
					<thead>
						<th class="text-center">ID</th>
						<th class="text-center">Nombre</th>
						<th class="text-center">Año</th>
						<th class="text-center">Creación</th>
						<th class="text-center">Asignado</th>
					</thead>
					<tbody>
						<tr v-for="(item, index) in listInventoryTemplates" :key="index">
							<td class="text-center">{{item.id}}</td>
							<td>{{item.name}}</td>
							<td class="text-center">{{item.inventory.year}}</td>
							<td class="text-center">{{item.created_at}}</td>
							<td class="">
								<div v-for="(ite, inde) in item.inventory_template_employee" :key="inde">
									{{ ite.surname }} {{ ite.name }}
								</div>
								<div class="text-right">
									<span @click="showAssignInventoryTemplateEmployeeModal(item)" class="pointer text-primary">asignar</span>
								</div>
							</td>
							<td>
								<router-link :to="'/inventory/template/' + item.id" class="far fa-eye pointer text-info"></router-link>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>


<!-- Button trigger modal -->
<button type="button" class="btn btn-primary" data-toggle="modal" data-target="#assignInventoryTemplateEmployeeModal" ref="btnShowAssignInventoryTemplateEmployeeModal" v-show="false">
	Asignar Planilla
</button>

<!-- Modal -->
<div class="modal fade" id="assignInventoryTemplateEmployeeModal" tabindex="-1" aria-labelledby="assignInventoryTemplateEmployeeModal" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="assignInventoryTemplateEmployeeModal">Asignar Planilla {{objectInventoryTemplate.id}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div>
			<label>Nombre planilla</label> <span>{{objectInventoryTemplate.name}}</span>
		</div>
		<div>
			<select class="form-control form-control-sm" v-model="employeeIdSelected">
				<option v-for="(item, index) in listEmployees" :key="index" :value="item.id">{{ item.surname }} {{ item.name }}</option>
			</select>
		</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Cerrar</button>
        <button type="button" class="btn btn-sm btn-primary" @click="saveInventoryTemplateEmployeeLocal" :disabled="employeeIdSelected == 0">Asignar</button>
      </div>
    </div>
  </div>
</div>



	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import inventoryTemplate from '@/mixins/inventories/inventoryTemplate.js'
import employee from '@/mixins/employees'
import stores from '@/mixins/stores'

export default {
	name: 'InventoryTemplatesComponent',
	mixins: [axiosAction, errors, mixin, stores, inventoryTemplate, employee],
	data () {
		return {
			storeId: 0,
			storeRackId: 0,
			storeRackModuleId: 0,
			searching: false,
			value: ''
		}
	},
	computed: {
		listStoreRackModulesLocal() {
			let list = this.listStoreRackModules.filter(item => {
				return !item.selected
			})
			return list
		}
	},
	methods: {
		addListStoreRackModulesSelected(item) {
			let index = this.listStoreRackModules.map((el) => parseInt(el.id)).indexOf(parseInt(item.id))
			this.listStoreRackModules[index].selected = true
			this.objectInventoryTemplate.inventory_template_store_rack_modules.push(item)
		},
		initModuleLocal() {
			this.getAllEmployeesLocal()
			this.getAllStoresLocal()
			this.getAllInventoryTemplatesLocal()
			this.objectInventoryTemplate.inventory_id = 1
		},
		getAllEmployeesLocal() {
			this.getAllEmployees()
		},
		getAllEmployeesResultLocal(response) {},
		getAllInventoryTemplatesLocal() {
			this.getAllInventoryTemplates()
		},
		getAllInventoryTemplatesResultLocal(response) {
			
		},
		getAllStoresLocal() {
			this.getAllStores()
		},
		getAllStoresResultLocal(response) {
			if(response.data.success == true) {
				this.value = 'racks'
				this.getAllStoreRacks()
			} else {
				this.searching = false
			}
		},
		getAllStoreRacksResultLocal(response) {
			if(response.data.success == true) {
				this.value = 'modulos'
				this.getAllStoreRackModules()
			} else {
				this.searching = false
			}
		},
		getAllStoreRackModulesResultLocal(response) {
			this.searching = false
		},
		removeListStoreRackModulesSelected(index) {
			let ind = this.listStoreRackModules.map((el) => parseInt(el.id)).indexOf(parseInt(this.objectInventoryTemplate.inventory_template_store_rack_modules[index].id))
			this.listStoreRackModules[ind].selected = false
			return this.objectInventoryTemplate.inventory_template_store_rack_modules.splice(index, 1)
		},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'getAllEmployeesResult': this.getAllEmployeesResult(response); break;
				case 'getAllInventoryTemplatesResult': this.getAllInventoryTemplatesResult(response); break;
				case 'getAllStoresResult': this.getAllStoresResult(response); break;
				case 'getAllStoreRacksResult': this.getAllStoreRacksResult(response); break;
				case 'getAllStoreRackModulesResult': this.getAllStoreRackModulesResult(response); break;
				case 'saveInventoryTemplateResult': this.saveInventoryTemplateResult(response); break;
				case 'saveInventoryTemplateEmployeeResult': this.saveInventoryTemplateEmployeeResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
			this.$emit('hideLockScreen')
		},
		saveInventoryTemplateLocal() {
			this.saveInventoryTemplate(this.objectInventoryTemplate)
		},
		saveInventoryTemplateResultLocal(response) { },
		saveInventoryTemplateEmployeeLocal() {
			let data = {
					exist: 0,
					id: 0,
					inventory_template_id: this.objectInventoryTemplate.id,
					employee_id: this.employeeIdSelected
				}
			this.saveInventoryTemplateEmployee(this.objectInventoryTemplate.id, data)
		},
		saveInventoryTemplateEmployeeResultLocal(response) {
			if(response.data.success == true) {
				let index = this.listInventoryTemplates.map((el) => parseInt(el.id)).indexOf(response.data.data.inventory_template_id)
				if(index > -1) {
					this.listInventoryTemplates[index].inventory_template_employee.push(response.data.data.employee)
				}
			}
		},
		showAssignInventoryTemplateEmployeeModal(item) {
			this.employeeIdSelected = 0
			this.setObjectInventoryTemplate(item)
			this.$refs.btnShowAssignInventoryTemplateEmployeeModal.click()
		}
	},
	mounted () {
		this.initModule()
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.ul-list-store {
		padding-left: 10px;
		li {
			ul {
				padding-left: 10px;
			}
		}
	}
	.li:hover {
		font-weight: bold;
	}
</style>
